<template><div class="login-wrapper">
  <div class="login-container">
  
    <div v-if="!registerUserInfo&&this.$store.state.auth!=4">
        <h3>{{ $t("EnterCode") }}</h3>
      <input type="text" required
           class="input-field code_input"
           minlength="6"
           maxlength="6"
          v-model="finalcode"/>
          <!--  -->
             <p
          style="margin-top: 15px; margin-bottom: 0"
          v-if="$i18n.locale == 'en'"
        >
          {{ countDown }} second
        </p>
        <p style="margin-top: 15px; margin-bottom: 0" v-else>
          {{ countDown }} ثانية
        </p>
        <div
          v-if="validateMessage != ''"
          style="text-align: center; margin-top: 10px; margin-bottom: 0"
        >
          <span style="color: red; margin: 0">{{ validateMessage }}</span>
        </div>
        <div
          v-if="validateMessage1 != ''"
          style="text-align: center; margin-top: 10px; margin-bottom: 0"
        >
          <span style="color: var(--primary-color); margin: 0">{{
            validateMessage1
          }}</span>
        </div>
        <div class="text-center w-100 mt-3">
       
          <p v-if="this.$store.state.auth==0" class="alert_msg" style="color:red"> {{ $t('The message could go to junk mail or spam') }} </p>

        </div>
          <!--  -->
      <button  v-if="countDown==0"  type="submit"  @click="ResendCode()" 
      :disabled="countDown==0" class="signin"
       style="margin-top: 25px;">{{ $t("ResendCode") }}
       <i class="fa fa-spinner fa-spin " v-if="loading_register"></i>
      </button>

      <button v-else  type="submit" @click="checkCode"  :disabled="countDown==0" 
      class="signin" style="margin-top: 25px;">{{ $t("continue") }}
     <i class="fa fa-spinner fa-spin " v-if="loading_register"></i></button>
    </div>
    <div v-if="registerUserInfo||this.$store.state.auth==4">
      <user-info :phone="phone" :email="email"></user-info>
    </div>
  </div>
  
</div>
</template>
<script>
import UserInfo from "../components/UserInfo.vue";

export default {
  components: {UserInfo },
  props: {
    phone: String,
    email: String,
  },
  data: function () {
    return {
      registerUserInfo: false,
      checkcomplete: false,
      validateMessage: "",
      validateMessage1: "",
      finalcode: null,
      countDown: 90,
      loading_register:false
    };
  },
  created() {
    this.$store.state.showHeader=true;
    this.$store.state.showFooter=true;
    this.countDownTimer();
  },
  methods: {
    checkCode() {
      this.loading_register=true;
      if (this.finalcode!=null&&this.finalcode!='') {
        if (this.$store.state.auth == 1) {
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/register_code",
              {
                /*/register_code*/
                phone: this.phone,
                code: this.finalcode,
                fcm_token: this.$store.state.fsm_token
              },
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
              },
            }
          )
          .then((response) => {
             this.loading_register=false;
            if (response.data.code == "-1") {
              //  console.log( response.data.code);
              this.validateMessage = response.data.message;
              setTimeout(() => {
                this.validateMessage = "";
              }, 3000);
            } else if (response.data.code == "1") {
              this.registerUserInfo = true;
              if(response.data.data.token)
              this.$localStorage.set(
                  this.$store.storeName,
                  response.data.data.token
                );
                
            }
          });
        }else {
          ///for register by email
          this.axios
            .post(
              this.$store.state.base_api_url +
                this.$store.storeName +
                "/register_code/byemail",
              {
                email: this.email,
                code: this.finalcode,
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
                this.loading_register=false;
              if (response.data.code == "-1") {
                //  console.log( response.data.code);
                this.validateMessage = response.data.message;
                setTimeout(() => {
                  this.validateMessage = "";
                }, 3000);
              } else if (response.data.code == "1") {
                this.registerUserInfo = true;
                //console.log( response.data.code);
                //console.log( response.data.message);
              }
            });
        }
      } else {
              this.loading_register=false;
        if (this.$i18n.locale == "en") {
          this.validateMessage = "your code isn't complete";
            this.loading_register=false;
          setTimeout(() => {
            this.validateMessage = "";
          }, 3000);
        } else {
          this.validateMessage = "يرجى إكمال كافة الحقول";
            this.loading_register=false;
          setTimeout(() => {
            this.validateMessage = "";
          }, 3000);
                        this.loading_register=false;

        }
          this.loading_register=false;
      }
    },
    ResendCode() {
       this.loading_register=true;
      if (this.$store.state.auth == 1) {
      this.axios
        .post(
          this.$store.state.base_api_url +
            this.$store.storeName +
            "/app/genret_code",
          {
            phone: this.phone,
            //country: this.form.country,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
           this.loading_register=false;
          if (response.data.code == "-1") {
            this.validateMessage = response.data.message;
            setTimeout(() => {
              this.validateMessage = "";
            }, 3000);
          } else if (response.data.code == "1") {
            this.countDown = 90;
            this.countDownTimer();
            this.validateMessage1 = response.data.message;
            setTimeout(() => {
              this.validateMessage1 = "";
            }, 3000);
          }
        });
      }else {
        this.axios
          .post(
            this.$store.state.base_api_url +
              this.$store.storeName +
              "/genret_code/byemail",
            {
              email: this.email,
              //country: this.form.country,
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
              },
            }
          )
          .then((response) => {
             this.loading_register=false;
            if (response.data.code == "-1") {
              this.validateMessage = response.data.message;
              setTimeout(() => {
                this.validateMessage = "";
              }, 3000);
            } else if (response.data.code == "1") {
              this.countDown = 90;
              this.countDownTimer();
              this.validateMessage1 = response.data.message;
              setTimeout(() => {
                this.validateMessage1 = "";
              }, 3000);
            }
          });
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
 
  },
};
</script>